import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SwapWifiService } from 'src/app/services/swap-wifi.service';
import { ConfirmDialogService } from '../swap-wifi-shared-module/confirm-dialog/confirm-dialog.service';
import { Subject, Subscription, switchMap } from 'rxjs';
import { DetailPopupComponent } from '../swap-wifi-shared-module/detail-popup/detail-popup.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-list-contract',
  templateUrl: './list-contract.component.html',
  styleUrls: ['./list-contract.component.scss'],
})
export class ListContractComponent implements OnInit {
  utmSource: any;
  locationId: any;
  utmExtraBranchcode: any;
  utmExtraMac: any;
  merchant: any;
  constructor(
    readonly route: ActivatedRoute,
    readonly router: Router,
    readonly swapWifiService: SwapWifiService,
    readonly spinner: NgxSpinnerService,
    readonly confirm: ConfirmDialogService,
    readonly modalService: NgbModal
  ) {
    this.route.queryParams.subscribe((params: any) => {
      this.utmSource = params['utm_source'];
      this.locationId = params['locationid'];
      this.utmExtraBranchcode = params['utm_extra_branchcode'];
      this.utmExtraMac = params['utm_extra_mac'];
      this.phoneNumber = params['phone_nb'];
      this.merchant = params['merchantId'];
    });
  }
  //@ts-ignore
  adviseSubscription: Subscription;
  readonly adviseSubject = new Subject();
  contentLoaded: boolean = false;
  phoneNumber: any;
  currentContract: any;
  data: any = {
    upgraded_contract: {
      text: 'Hợp đồng đã nâng cấp',
      list_contract: [
        {
          contract_no: 'IAOTIPPP',
          full_name: 'Nguyễn Quỳnh Anh',
          phone_nb: '*******3789',
          address: '*** Nguyễn Bỉnh Khiêm kéo dài, Phường 3, Quận 5, TP. HCM',
          status: {
            code: 'Swapped',
            text: 'Hợp đồng đã nâng cấp',
            is_retry: 0,
          },
        },
        {
          contract_no: 'IAOTIPPP',
          full_name: 'Nguyễn Quỳnh Anh',
          phone_nb: '*******3789',
          address: '*** Nguyễn Bỉnh Khiêm kéo dài, Phường 3, Quận 5, TP. HCM',
          status: {
            code: 'Swapping',
            text: 'Hợp đồng đang nâng cấp',
            is_retry: 0,
          },
        },
      ],
    },
    not_upgraded_contract: {
      text: 'Hợp đồng chưa nâng cấp',
      list_contract: [
        {
          contract_no: '****924',
          full_name: 'Nguyễn Văn A',
          phone_nb: '********410',
          address: '*** Nguyễn Bỉnh Khiêm kéo dài, Phường 3, Quận 5, TP. HCM',
          status: {
            code: 'Valid',
            text: 'Nâng cấp',
          },
        },
        {
          contract_no: '****924',
          full_name: 'Nguyễn Văn A',
          phone_nb: '********410',
          address: '*** Nguyễn Bỉnh Khiêm kéo dài, Phường 3, Quận 5, TP. HCM',
          status: {
            code: 'Invalid',
            text: 'Tư vấn',
          },
        },
      ],
    },
  };
  getListContract() {
    let data = {
      phone_nb: this.phoneNumber,
      utm_source: this.utmSource,
      location_id: this.locationId ? this.locationId : undefined,
      branch_code: this.utmExtraBranchcode ? this.utmExtraBranchcode : undefined,
      mac: this.utmExtraMac ? this.utmExtraMac : undefined,
    };
    const version = this.getSwapWifiVersion();
    this.swapWifiService.getListContract(version, data).subscribe((res: any) => {
      if (res) {
        this.data = res.detail;
        this.contentLoaded = true;
      }
    });
  }
  getSwapWifiVersion() {
    if (this.merchant === 'SWAP_WIFI7') {
       return '7'
    }
    return '6';
  }
  ngOnInit(): void {
    this.getListContract();
    const version = this.getSwapWifiVersion();
    this.adviseSubscription = this.adviseSubject
      .pipe(switchMap((data) => this.swapWifiService.getInfo(version, data)))
      .subscribe(
        (res: any) => {
          this.spinner.hide();
          if (res && res.status !== 1) {
            this.confirm.confirm(
              'Thông báo',
              res.msg,
              'Đồng ý',
              undefined,
              'justify-content-center'
            );
          }
        },
        (errors: any) => {
          this.spinner.hide();
        }
      );
  }
  handleAdvise(item: any) {
    this.spinner.show();
    this.adviseSubject.next({
      utm_source: this.utmSource,
      contract_no: item.contract_no_encode,
      phone_nb: this.phoneNumber,
      location_id: this.locationId ? this.locationId : undefined,
      branch_code: this.utmExtraBranchcode ? this.utmExtraBranchcode : undefined,
      mac: this.utmExtraMac ? this.utmExtraMac : undefined,
    });
  }
  gotoDetail(contract_no_encode: string, trans_id?: any) {
    const url = this.merchant ? './swap-wifi' : './swap-wifi-6';
    this.router.navigate([url], {
      queryParams: {
        utm_source: this.utmSource,
        contractNo: contract_no_encode,
        phone_nb: this.phoneNumber,
        trans_id: trans_id,
        locationid: this.locationId ?? undefined,
        utm_extra_branchcode: this.utmExtraBranchcode ?? undefined,
        utm_extra_mac: this.utmExtraMac ?? undefined,
        merchantId: this.merchant ?? undefined,
      },
    });
  }
  checkUpdated(item: any) {
    if (item.get_detail.length > 1) {
      let width = window.screen.width;
      const modalRef = this.modalService.open(DetailPopupComponent, {
        windowClass: width > 767 ? 'detail-popup' : 'pull-up-detail-popup',
        centered: true,
      });
      modalRef.componentInstance.title = 'Xem chi tiết giao dịch';
      modalRef.componentInstance.dataIn = item.get_detail;
      modalRef.componentInstance.className = width > 767 ? 'detail-popup' : 'pull-up-detail';
      modalRef.componentInstance.modalEvent.subscribe((res: any) => {
        if (res) {
          this.gotoDetail(this.currentContract, res.trans_id);
        }
        return modalRef.result;
      });
      this.currentContract = item.contract_no_encode;

    } else if (item.get_detail.length === 1) {
      this.gotoDetail(item.contract_no_encode, item.get_detail[0].trans_id);
    }
  }
  ngOnDestroy(): void {
    this.adviseSubscription.unsubscribe();
  }
}
